import styles from "./StatusPill.module.css";

type Tone =
  | "available"
  | "pending"
  | "sent"
  | "to-send"
  | "neutral"
  | "resend";

interface StatusPillProps {
  tone: Tone;
  children: React.ReactNode;
}

export function StatusPill({ tone, children }: StatusPillProps) {
  return <span className={`${styles.pill} ${styles[tone]}`}>{children}</span>;
}
